import React, {useCallback} from 'react';
import Link from '@docusaurus/Link';
import useBaseUrl from '@docusaurus/useBaseUrl';
import useDocusaurusContext from '@docusaurus/useDocusaurusContext';
import {useThemeConfig} from '@docusaurus/theme-common';

function shouldLetBrowserHandleClick(event) {
  return (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey
  );
}

function forceLandingTheme() {
  const root = document.documentElement;

  root.setAttribute('data-theme', 'light');
  root.removeAttribute('data-pdfbolt-docs-color-scope');

  try {
    window.localStorage.setItem('theme', 'light');
  } catch (error) {
    // Keep navigation working if storage is unavailable.
  }
}

export default function NavbarLogo() {
  const {
    siteConfig: {title},
  } = useDocusaurusContext();
  const {
    navbar: {title: navbarTitle, logo},
  } = useThemeConfig();
  const baseHomeUrl = useBaseUrl('/');
  const homeUrl = useBaseUrl(logo?.href || '/');
  const logoSrc = useBaseUrl(logo?.src || '');
  const fallbackAlt = navbarTitle ? '' : title;
  const alt = logo?.alt ?? fallbackAlt;

  const handleClick = useCallback(
    (event) => {
      if (shouldLetBrowserHandleClick(event)) {
        return;
      }

      if (homeUrl === baseHomeUrl) {
        forceLandingTheme();
      }
    },
    [baseHomeUrl, homeUrl],
  );

  return (
    <Link
      className="navbar__brand"
      to={homeUrl}
      {...(logo?.target && {target: logo.target})}
      aria-label="PDFBolt home"
      onClick={handleClick}
    >
      {logo && (
        <div className="navbar__logo" aria-hidden={alt === ''}>
          <img
            className={logo.className}
            src={logoSrc}
            alt={alt}
            height={logo.height}
            width={logo.width}
            style={logo.style}
          />
        </div>
      )}
      {navbarTitle != null && (
        <b className="navbar__title text--truncate">{navbarTitle}</b>
      )}
    </Link>
  );
}
